"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTZOffsetHours = exports.getTZOffsetMins = void 0;
const luxon_1 = require("luxon");
const getTZOffsetMins = (ianaZone, date) => {
    return luxon_1.IANAZone.create(ianaZone).offset(date?.valueOf() ?? Date.now());
};
exports.getTZOffsetMins = getTZOffsetMins;
const getTZOffsetHours = (ianaZone, date) => (0, exports.getTZOffsetMins)(ianaZone, date) / 60;
exports.getTZOffsetHours = getTZOffsetHours;
